import {Feature} from '@/services/OverlaysService';
import {importKMx} from '@/lib/kml/kmlImport';
import {ImageGraphic} from './GraphicService/ImageGraphic/ImageGraphic';

const _concealmentFeatures = new Map<string, Feature>();
const _concealmentGraphics = new Map<string, ImageGraphic>();

// This interface is copied from the response provided by the V1 storage.googleapis.com API
interface StorageGoogleAPIObject {
  bucket: string;
  contentType: string;
  crc32c: string;
  etag: string;
  eventBasedHold: boolean;
  generation: string;
  id: string;
  kind: string;
  md5Hash: string;
  mediaLink: string;
  metageneration: string;
  name: string;
  selfLink: string;
  size: string;
  storageClass: string;
  temporaryHold: boolean;
  timeCreated: string;
  timeFinalized: string;
  timeStorageClassUpdated: string;
  updated: string;
}

/** A service for managing map concealments. */
const Concealments = {
  /** Retrieves KMZs used for concealment from Storage and adds them to the map. */
  createMapConcealments: async () => {
    const env = process.env.VUE_APP_GCP_ENV === 'production' ? 'Prod' : 'Staging';
    const CONCEALMENT_FOLDER_LINK = `https://storage.googleapis.com/storage/v1/b/beyond_maps_public/o?prefix=Map_Concealments_${env}/&delimiter=/`;

    const response = await fetch(CONCEALMENT_FOLDER_LINK);
    const items = (await response.json()).items as StorageGoogleAPIObject[];
    const kmzFiles = items.filter((item) => item.name.endsWith('.kmz'));

    await Promise.allSettled(kmzFiles.map(async (kmz) => {
      try {
        const media = await fetch(kmz.mediaLink);
        const blob = await media.blob();
        const {features} = await importKMx(new File([blob], kmz.name, {type: blob.type}));

        for (const feature of features) {
          const f = new Feature({...feature, id: `concealment-feature-${feature.name}`});
          const g = new ImageGraphic(feature.graphicData);

          _concealmentFeatures.set(f.id, f);
          _concealmentGraphics.set(g.uuid, g);

          g.setClickable(false);
          f.setGraphic(g);
          await f.setZIndex(false, -1000, -1000);
        }
      } catch (error) {
        if (error instanceof Error) {
          error.message = `Could not add concealment "${kmz.name}": ${error.message}`;
        }
        console.error(error);
      }
    }));
  },
  /** Sets the map for all concealment graphics. */
  setMap: (map: google.maps.Map | null) => {
    _concealmentGraphics.forEach((graphic) => graphic.setMap(map));
  },
};

export {
  Concealments,

  // Testing
  _concealmentFeatures,
  _concealmentGraphics,
};
